<template>
  <div
    v-if="hasNavigation"
    class="navigation overflow-hidden"
    :class="[
      $device.isMobile ? '' : 'bg-secondary',
      {'left-navigation h-100': !$device.isMobile},
    ]"
  >
    <div
      v-if="!$device.isMobile"
      class="logo-container cursor-pointer w-100"
      @click="goPage('home')"
    >
      <img
        :src="require('@/assets/img/login/base-logo-white.png')"
        class="img-fluid"
      />
    </div>
    <b-nav
      class="navigation-container align-items-center overflow-auto scroll-bar"
      :class="[$device.isMobile ? 'bg-white' : '']"
      justified
    >
      <b-nav-item
        v-for="tab of tabs"
        :key="tab.label"
        class="cursor-pointer position-relative"
        :active="tab.isActive"
        :class="[$device.isMobile ? 'text-12' : 'text-14']"
        @click="tab.click"
      >
        <i class="text-32" :class="tab.iconClass"></i>
        <p class="m-0">{{ $t(tab.label) }}</p>
        <div
          v-if="tab.hasNotification"
          class="notification bg-accent position-absolute"
        ></div>
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
import NAVIGATION from '@/constant/navigation.js';

export default {
  data() {
    return {};
  },
  computed: {
    hasVerificationNotification() {
      return this.$store.state.env.hasVerificationNotification;
    },

    hasNavigation() {
      return this.$route.meta?.hasNavigation;
    },

    isSidebarShow() {
      return this.$store.state.env.isSidebarShow;
    },
    isTeacher() {
      return this.$store.getters['user/isTeacher'];
    },

    tabs() {
      const activeTab = this.$route?.meta?.activeTab;
      const list = [
        {
          label: '玩',
          iconClass: 'icon-Home',
          isActive: activeTab === NAVIGATION.TABS.PLAY,
          hasNotification: false,
          click: () => {
            this.goPage('play');
          },
        },
        {
          label: '學',
          iconClass: 'icon-Go-Kifu2',
          isActive: activeTab === NAVIGATION.TABS.LEARNING,
          hasNotification: false,
          click: () => {
            this.goPage('learning');
          },
        },
        {
          label: '更多',
          iconClass: 'icon-Dots-circle-horizontal',
          isActive: activeTab === NAVIGATION.TABS.MORE,
          hasNotification: this.hasVerificationNotification,
          click: () => {
            if (this.$device.isMobile) {
              this.goPage('more');
            } else {
              this.$store.commit('env/setIsSidebarShow', !this.isSidebarShow);
              this.$store.commit('env/setIsSwitchCourseSheetShow', false);
            }
          },
        },
      ];
      if (this.isTeacher) {
        list.unshift({
          label: '教師',
          iconClass: 'icon-school',
          isActive: activeTab === NAVIGATION.TABS.TEACHER,
          hasNotification: false,
          click: () => {
            this.goPage('teacherManagement');
          },
        });
      }
      return list;
    },
  },
  methods: {
    async goPage(name) {
      if (this.$route.name !== name) {
        this.$router.push({name});
        await this.$nextTick();
        const element = document.querySelector('#main');
        element?.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  background: $bgcontainer;
  .logo-container {
    padding: 8px 10px;
    margin: 0 0 8px;
    img {
      width: 100px;
    }
  }
  .navigation-container {
    box-shadow: inset 0 1px 0 0 $line-2;
    min-height: 78px;
    border-radius: var(--Radius-radius-l, 20px) var(--Radius-radius-l, 20px) 0px
      0px;
    border-top: 1px solid var(--Line-Line, #dcdfe5);
  }
  .nav-item {
    display: flex;
  }
  .nav-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;
    padding: 0;
    height: 62px;
    width: 78px;
    color: $font-normal;
    border-radius: $rounded-md;
    position: relative;
    &.active {
      border-radius: var(--Radius-radius-m, 10px);
      background: var(--Color-PapayaWhip, #fff1de);
    }
  }

  .notification {
    width: 14px;
    height: 14px;
    top: 10px;
    right: 9px;
    border-radius: 50%;
  }

  &.left-navigation {
    position: relative;
    z-index: 1040;
    .navigation-container {
      box-shadow: none;
      flex-direction: column;
      flex-wrap: nowrap;
      max-width: 120px;
      height: calc(100% - 139px);
      border-radius: 0px;
      border-top: 0px;
    }

    .nav-link {
      width: 84px;
      height: 80px;
      color: white;
      &:hover {
        background: rgba(255, 255, 255, 0.15);
      }
      &.active {
        background: rgba(255, 255, 255, 0.3);
      }
    }
    .nav-item {
      margin-bottom: 8px;
      max-height: 80px;
    }
  }
}
</style>
